import React, { useEffect, useState } from "react"
import { Button, Input, Modal, ModalBody, ModalHeader, Table } from "reactstrap"
import { getQuoteRequest, getAcceptRedeemQuote, getRejectRedeemQuote } from "../services/waitlist-service";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { isMobile } from "react-device-detect";
import Loader from "react-loaders";
import InfoPopup from "./InfoPopup";
import { middlewareService } from "../../shared/service";
import middlewareConstants from "../../shared/middleware-constant";

export default function LiquidationMldFirst(props) {
    const history = useHistory();
    const [checked, setChecked] = useState(false);
    const [checkedTwo, setCheckedTwo] = useState(false);
    const [disable, setDisable] = useState(false);
    const [showSection, setShowSection] = useState(true);
    const [redeemed, setRedeemed] = useState()
    const [showModal, setShowModal] = useState(false);
    const [isLive, setIsLive] = useState(false);
    const [showPopUpText, setShowPopupText] = useState(false);
    const [popUpOverText, setPopUpOverText] = useState("");
    const [showPopUpTextEligible, setShowIndicativeInfo] = useState(false);
    const [popUpOverTextEligible, setPopUpOverTextEligible] = useState('');
    const [liquidationAmount, setLiquidationAmount] = useState();


    const toggle = () => {
        setShowModal(!showModal);
    };

    const handleClick = () => {
        if (props?.liquidationDetails?.availableUnits < 1) {
            return toast.error("Insufficient eligible unit")
        } if (props?.units === 0) {
            return toast.error("Enter units")
        } else {
            setConsent()
            getQuoteRequest(props.bondDetails.ISIN, { "X-product": `orobonds:${props.bondDetails.product}` }, props.units, 0).then(
                (res) => {
                    if (res) {
                        props.showSecond(true)
                        setDisable(true)
                        setShowSection(false)
                    }
                },
                (err) => {
                    toast.error("Error calling the API:", err);
                }
            );
        }
    }

    const setConsent = () => {
        let _url = "/users/setConsent";
        let payload = {
            type: "redeem",
            consent: true

        };
        let requestOptions = middlewareConstants.requestWithCredentialsJsonBSE;
        requestOptions.body = new URLSearchParams(payload);
        middlewareService
            .servicePost(process.env.REACT_APP_REPORTS_API_URL + _url, requestOptions)
            .then((response) => {
                if (!response || !response.successs) {
                    console.log("something went wrong");
                }
            });
    };

    const handleRedeemClick = () => {
        setConsent()
        getAcceptRedeemQuote(props.bondDetails.ISIN, { "X-product": `orobonds:${props.bondDetails.product}` }, redeemed.units, 0).then(
            (res) => {
                if (res) {
                    props.setShowForth(true)
                    setShowSection(false)
                }
            },
            (err) => {
                toast.error("Error calling the API:", err);
            }
        );
    }

    const handleCancelClick = () => {
        if (props.orderId) {
            getRejectRedeemQuote(props.bondDetails.ISIN, { "X-product": `orobonds:${props.bondDetails.product}` }, props.orderId, 0).then(
                (res) => {
                    if (res) {
                        window.location.href = process.env.REACT_APP_NEUTRAL_POST_URL + '/portfolio';
                    }
                },
                (err) => {
                    toast.error("Error calling the API:", err);
                }
            );
        } else {
            window.location.href = process.env.REACT_APP_NEUTRAL_POST_URL + '/portfolio';
        }
    }

    useEffect(() => {
        if (props.liquidationRedeem) {
            setRedeemed(props.liquidationRedeem[0].amountBreakup)
        }
    }, [props.liquidationRedeem])

    useEffect(() => {
        if (props.orderId) {
            if (props?.liquidationDetails?.priceIsLive) {
                return setIsLive(true)
            }
        } else {
            return setIsLive(true)
        }
    }, [props])

    const handleNotLive = () => {
        window.location.href = process.env.REACT_APP_NEUTRAL_POST_URL + '/portfolio';
    }

    const handleInfoLockedClick = () => {
        setShowPopupText(!showPopUpText)
        setPopUpOverText("Units for which Liquidation request is under process")
    }

    const handleIndicativeClick = () => {
        setShowIndicativeInfo(!showPopUpTextEligible)
        setPopUpOverTextEligible("This is the Indicative price of the MLD. A fresh quote will be shared with you once you click on ‘Request Quote’.")
    }

    useEffect(() => {
        if (props && redeemed) {
            // let amount = (redeemed?.ispUnitPrice - (props?.liquidationDetails?.exitLoadInPerc / 100) * (redeemed?.ispUnitPrice));
            setLiquidationAmount(redeemed.ispUnitPrice)
        }
    }, [props, redeemed])

    return (
        <div className="table-wrapper">
            <Table bordered className="text-center liq-table">
                <th colSpan={2} className="header">
                    Liquidation Overview
                </th>
                <tr className="tr">
                    <td className="w-50 font-weight-semi-bold">Issue details</td>
                    <td className="w-50 font-weight-semi-bold">{props?.bondDetails?.productName}</td>
                </tr>
                <tr className="tr">
                    <td className="w-50 font-weight-semi-bold">{redeemed ? "Price per unit" : <>Indicative price per unit
                        {!disable && <span
                            onClick={handleIndicativeClick}
                            className="mdi mdi-information-outline ml-2"
                            style={{
                                cursor: "pointer",
                                fontSize: "15px",
                            }}
                        />}
                    </>}</td>
                    <td className="w-50 font-weight-semi-bold">{redeemed ? redeemed?.priceWithoutExitLoad.oroNumber(2, true) : (props?.liquidationDetails?.unitPrice * props?.liquidationDetails?.units).oroNumber(2, true)}</td>
                </tr>
                {redeemed && <tr>
                    <td className="w-50 font-weight-semi-bold">Liquidation cost</td>
                    <td className="w-50 font-weight-semi-bold">{props?.liquidationDetails?.exitLoadInPerc}%</td>
                </tr>}
                {redeemed && <tr>
                    <td className="w-50 font-weight-semi-bold">Redemption price per unit
                    </td>
                    <td className="w-50 font-weight-semi-bold">{liquidationAmount ? liquidationAmount.oroNumber(2, true) : null}</td>
                </tr>}
                {!redeemed && <tr className="tr">
                    <td className="w-50 font-weight-semi-bold">Total units</td>
                    <td className="w-50 font-weight-semi-bold">{props?.liquidationDetails?.totalUnits}</td>
                </tr>}
                {!redeemed ?
                    <>
                        {
                            props?.liquidationDetails?.totalUnits !== props?.liquidationDetails?.availableUnits &&
                            <tr className="tr">
                                <td className="w-50 font-weight-semi-bold">Locked units <span
                                    onClick={handleInfoLockedClick}
                                    className="mdi mdi-information-outline ml-2"
                                    style={{
                                        cursor: "pointer",
                                        fontSize: "15px",
                                    }}
                                /></td>
                                <td className="w-50 font-weight-semi-bold">{(props?.liquidationDetails?.lockedUnits)}</td>
                            </tr>
                        }
                        {props?.liquidationDetails?.totalUnits !== props?.liquidationDetails?.availableUnits &&
                            <tr className="tr">
                                <td className="w-50 font-weight-semi-bold">Eligible units
                                </td>
                                <td className="w-50 font-weight-semi-bold">{(props?.liquidationDetails?.availableUnits)}</td>
                            </tr>
                        }
                    </>
                    : null
                }
                <tr className="tr">
                    <td className="w-50 font-weight-semi-bold ">{redeemed ? "Requested units" : disable ? "Units requested for liquidation" : "Enter units to be liquidated"}</td>
                    {showSection && !redeemed ?
                        <td>
                            <div className='input-units'>
                                <div className='d-flex ip'>
                                    <Button onClick={props.decreaseUnits} disabled={!props?.liquidationDetails?.availableUnits} className="ip-btn">-</Button>
                                    <Input
                                        style={props.units <= 0 ? { color: "#cfcfcf", fontSize: "12px" } : {}}
                                        value={props.units <= 0 ? "Enter Units" : props.units}
                                        onChange={(e) => props?.setUnitsFunc(e.target.value)}
                                        pattern="[0-9]*"
                                        inputMode="numeric"
                                        placeholder="Enter Units"
                                        disabled={!props?.liquidationDetails?.availableUnits}
                                        className="text-center inp"
                                    />
                                    <Button onClick={props?.increaseUnits} disabled={!props?.liquidationDetails?.availableUnits} className="ip-btn">+</Button>
                                </div>
                            </div>
                        </td> :
                        <td className="w-50 font-weight-semi-bold">{redeemed ? redeemed.units : props?.units}</td>
                    }
                </tr>
                {/* {redeemed && <tr>
                    <td className="w-50 font-weight-semi-bold">Total price for requested units</td>
                    <td className="w-50 font-weight-semi-bold">{(redeemed.units * redeemed?.ispUnitPrice).oroNumber(2, true)}</td>
                </tr>} */}
                {redeemed && <tr className="tr">
                    <td className="w-50 font-weight-semi-bold">Total redemption amount </td>
                    <td className="w-50 font-weight-semi-bold">{redeemed.ispAmount.oroNumber(2, true)}</td>
                </tr>}
            </Table>

            {!props?.redemptionSuccess && <>{showSection &&
                <>
                    <div className="mt-5 mb-2">
                        {isLive ?
                            <>
                                {redeemed &&
                                    <>
                                        {/* <p className="footer">
                                            <input type="checkbox"
                                                defaultChecked={checkedTwo}
                                                onChange={() => setCheckedTwo(!checkedTwo)}
                                            />&nbsp;
                                            I hereby confirm that this is an execution only transaction without any interaction or advice given by the employee/relationship manager/sales person and the platform has not charged any advisory fee for this transaction
                                        </p> */}

                                    </>
                                }
                                {
                                    (props?.liquidationDetails?.availableUnits >= 1 || redeemed) ? <p className={"footer text-center mb-5"}>
                                        <input type="checkbox"
                                            defaultChecked={checked}
                                            onChange={() => setChecked(!checked)}
                                        />&nbsp;
                                        By proceeding, I accept the &nbsp;
                                        <a className="text-secondary" target="_blank" href={process.env.REACT_APP_URL_ENDPOINTS + "/terms-of-use/"}><b>Terms & Conditions</b></a>
                                    </p> : <>
                                        <p className="inactive-market font-weight-semi-bold">
                                            You don’t have any eligible units to liquidate now. This generally happens when
                                            <ol>
                                            <li> Units are non redeemable since there is a lock-in period of 21 days from the order processed date.</li> 
                                            <li> All redeemable units are in locked status i.e. liquidation request for these units is under process.</li>
                                            </ol>
                                            Please contact us at +91 8591871028 or +91 8928250817 or email us at <a href='mailto:connect@biddeasy.com'>connect@biddeasy.com</a> for any queries.
                                        </p>
                                        <div className="btn-holder">
                                            <Button outline onClick={handleNotLive}>Close</Button>
                                        </div>
                                    </>
                                }
                            </>
                            :
                            <>
                                <p className="inactive-market text-center font-weight-semi-bold">
                                    The quote is valid only during market hours. Please visit again during market hours to get a fresh quote.
                                </p>
                                <p className="inactive-market text-center mb-5 font-weight-semi-bold">
                                    Market hours are between 9.15 am to 3.30 pm from Monday to Friday (except on Market Holidays)
                                </p>
                                <div className="btn-holder">
                                    <Button outline onClick={handleNotLive}>Close</Button>
                                </div>
                            </>
                        }
                    </div>
                    {isLive && (props?.liquidationDetails?.availableUnits >= 1 || redeemed) &&
                        <div className="btn-holder">
                            <Button outline onClick={handleCancelClick}>Cancel Now</Button>
                            {redeemed ?
                                <Button onClick={handleRedeemClick} disabled={(!checked)}>Liquidate Now</Button> :
                                <Button onClick={handleClick} disabled={(!checked || !props?.units)}>Request Quote</Button>}
                        </div>
                    }
                </>
            }
            </>
            }

            {
                popUpOverText &&
                <InfoPopup
                    showPopUpText={showPopUpText}
                    toggleInfoPopup={handleInfoLockedClick}
                    text={popUpOverText}
                />
            }
            {
                popUpOverTextEligible &&
                <InfoPopup
                    showPopUpText={showPopUpTextEligible}
                    toggleInfoPopup={handleIndicativeClick}
                    text={popUpOverTextEligible}
                />
            }
        </div>
    )
}